var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"learncoin-section"},[_c('output-learncoin-manage',{attrs:{"showOperate":false,"tradeTypes":_vm.tradeTypes,"custom-params":{ accountType: 2, accountCode: '' }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }